<template>
  <div class="header-slider">
    <div class="black-bg"></div>
    <div class="slider-container">
      <transition-group name="slide" tag="div" class="slider">
        <div :key="currentSlide" class="slide">
          <img v-if="isFirstImageLoaded" :src="getImageUrl(currentSlide)" alt="Slider Image" />
          <div v-else class="black-bg-placeholder"></div>
        </div>        
      </transition-group>
    </div>
    <div class="slider-text">
      <h2>{{ $t("header") }}</h2>
      <div class="search-bar">
        <input type="text" :class="{
          'search-bar-input': langVar === 'ar',
          'search-bar-input search-bar-input-en': langVar === 'en',
        }" :placeholder="$t('searchMsg')" v-model="searchKey" @input="performSearch" />
        <div v-if="searchKey && searchResults && searchResults.length > 0" class="search-results">
          <ul>
            <li v-for="result in searchResults" :key="result.id">
              <a :href="'/product-details/' + result.id" style="font-size: 20px">{{ result.name }}</a>
              <a :href="'/product-details/' + result.id"><img
                  :src="result.imagee" :alt="result.name" style="
                    width: 30%;
                    max-width: 90px;
                    border-radius: 15px;
                    margin-right: 10%;
                  " /></a>
            </li>
          </ul>
          <nav v-if="totalPages > 1">
            <ul class="pagination justify-content-center">
              <li class="page-item">
                <a class="page-link" @click="nextPage">
                  <span aria-hidden="true"><i class="fa fa-chevron-right"></i></span>
                </a>
              </li>
              <li class="page-item">

                <a class="page-link" @click="prevPage">
                  <span aria-hidden="true"><i class="fa fa-chevron-left"></i></span>
                </a>
              </li>

            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import store from "../../store";
import Axios from "../../Axios";

export default {
  data() {
    return {
      generalSetting: {},
      searchResults: [],
      searchKey: "",
      currentPage: 1,
      totalPages: 1,
      slides: [],
      currentSlide: 0,
      autoplayInterval: null,
      langVar: store.state.currentLang,
      isImageLoading: false,
      isFirstImageLoaded: false,
    };
  },
  methods: {
    getImageUrl(index) {
      if (this.sliderImages[index].imgName) {
        return "https://jebsenboard.onrender.com/image/Sliders/" + this.sliderImages[index].imgName;
      }
      return "";
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.performSearch();
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.performSearch();
      }
    },

    fetchSliderImages() {
      Axios.get("https://jebsenboard.onrender.com/slidderImg")
        .then((response) => {
          // console.log(response.data);
          this.sliderImages = response.data;
          this.loadImage(this.sliderImages[this.currentSlide].imgName, this.currentSlide); // Pass the index as well
          this.startAutoplay();
        })
        .catch((error) => {
          // console.error(error);
        });
    },
    prevSlide() {
      this.currentSlide =
        (this.currentSlide - 1 + this.sliderImages.length) % this.sliderImages.length;
    },
    nextSlide() {
      if (!this.isImageLoading) {
        this.isImageLoading = true;
        this.currentSlide = (this.currentSlide + 1) % this.sliderImages.length;
        this.loadImage(this.sliderImages[this.currentSlide].imgName);
      }
    },
    loadImage(imageName, index) {
  const img = new Image();
  img.onload = () => {
    this.isImageLoading = false;
    if (index === 0) { // Check if it's the first image
      this.isFirstImageLoaded = true;
    }
  };
  img.src = "https://jebsenboard.onrender.com/image/Sliders/" + imageName;
},
    startAutoplay() {
      this.autoplayInterval = setInterval(() => {
        this.nextSlide();
      }, 3000);
    },
    stopAutoplay() {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    },
    performSearch() {
      // console.log("Performing search for:", this.searchKey);
      Axios.get(`/product/search`, {
        params: {
          limit: 6,
          searchkey: this.searchKey,
          page: this.currentPage,
        },
      })
        .then((response) => {
          // console.log(response);
          this.searchResults = response.data.data.map((product) => {
                if (
                  product.imagee &&
                  product.imagee.type === "Buffer" &&
                  Array.isArray(product.imagee.data)
                ) {
                  const buffer = Buffer.from(product.imagee.data);
                  const base64imagee = buffer.toString("base64");
                  product.imagee = `data:imagee/jpeg;base64,${base64imagee}`; // Adjust MIME type if needed
                }
                return {
                  id: product.id,
                  name: product.name,
                  imagee: product.imagee,
                };
              });
          this.totalPages = response.data.totalPages;
        })
        .catch((error) => {
          this.searchResults = [];
          // console.log(error);
        });
    },
  },
  mounted() {
    this.fetchSliderImages();
  },
  beforeDestroy() {
    this.stopAutoplay();
  },
  computed: {
    ...mapState(["currentLang"]),
    currentLang() {
      return store.state.currentLang;
    },
  },
};
</script>

<style scoped>
.black-bg {
  background-color: rgba(0, 0, 0, 0.46);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
}

.slider-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.header-slider {
  position: relative;
  width: 100%;
  overflow: hidden;
  height: 500px;
}

.slider {
  display: flex;
  transition: all 0.5s ease-in-out;
}

.slide {
  flex: 0 0 100%;
  position: relative;
}

.slide>img {
  width: 100%;
  height: 500px;
}

.slider-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  width: 100%;
  z-index: 3;
}

.slider-text h2 {
  font-size: 24px;
  color: #f9c752;
  font-weight: 800;
  margin-bottom: 30px;
}

.search-bar-input {
  width: 30%;
  padding: 10px;
  font-size: 16px;
  border: none;
  border-radius: 5px;
  box-shadow: 0px 0px 8px #888888;
  background-color: rgba(255, 255, 255, 0.81);
  font-weight: 600;
  color: #5a5a5a;
}

.search-bar-input-en {
  text-align: left;
}

.search-bar-input:hover {
  background-color: rgba(255, 255, 255, 0.84);
}

.search-results {
  width: 30%;
  margin-right: 35%;
  margin-top: 3px;
  background-color: rgba(255, 255, 255, 0.81);
  box-shadow: 0px 0px 8px #888888;
  border-radius: 5px;
  z-index: 4;
  text-align: left;
  max-height: 150px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #aaa #f5f5f5;
}

::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: #f5f5f5;
}

::-webkit-scrollbar-thumb {
  background: #f0bf4b;
  border-radius: 150px;
}

.search-results ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.search-results li {
  padding: 8px 10px;
  border-bottom: 1px solid gray;
}

.search-results a {
  text-decoration: none;
  color: #333;
}

.search-results li:last-child {
  border-bottom: none;
}

.black-bg-placeholder {
  width: 100%;
  height: 500px;
  background-color: rgba(0, 0, 0, 0.46);
}

@media (max-width: 850px) {

  .search-bar-input,
  .search-results {
    width: 70%;
  }

  .search-results {
    margin-right: 15%;
  }
}
</style>
